<template>
  <v-row>
    <!-- <v-col cols="12" sm="11" md="11"> -->
    <meeting-type-chip-group v-model="selectedMeetingTypes" @open="openMenu">
    </meeting-type-chip-group>
    <!-- </v-col>
    <v-col cols="12" sm="1" md="1" class="pl-0 alignMiddle"> -->
    <meeting-type-menu-list
      v-model="selectedMeetingTypes"
      :open.sync="openMeetingTypeMenu"
    ></meeting-type-menu-list>
    <!-- </v-col> -->
  </v-row>
</template>

<script>
import MeetingTypeChipGroup from "./MeetingTypeChipGroup.vue";
import MeetingTypeMenuList from "./MeetingTypeMenuList.vue";
export default {
  name: "MeetingTypeFilter",
  components: { MeetingTypeChipGroup, MeetingTypeMenuList },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedMeetingTypes: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
  },
  data() {
    return {
      //   selectedMeetingTypes: [],
      openMeetingTypeMenu: false,
    };
  },
  methods: {
    openMenu() {
      this.openMeetingTypeMenu = true;
    },
  },
};
</script>

<style>
</style>